import { StageConfig } from '../utils';
import { Icon } from '@/new/components/icon';
import { Skeleton } from '@/new/components/shadcn/skeleton';

export function UploadOverviewSkeleton() {
  return (
    <div className="rounded-md border border-gray-200 bg-white">
      <div className="border-b border-gray-200 bg-gray-50/80 px-4 py-2.5">
        <Skeleton className="h-5 w-24" />
      </div>
      <div className="p-4">
        <Skeleton className="h-[280px] w-full" />
      </div>
      <div className="border-t border-gray-100 p-4">
        <Skeleton className="mb-3 h-4 w-16" />
        <div className="grid gap-4 sm:grid-cols-2">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="flex gap-3">
              <Skeleton className="h-8 w-8 rounded" />
              <div className="flex-1 space-y-1">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function RunsProcessingSkeleton() {
  return (
    <div className="rounded-md border border-gray-200 bg-white">
      <div className="border-b border-gray-200 bg-gray-50/80 px-4 py-2.5">
        <h3 className="text-sm font-medium text-gray-600">File Flow</h3>
      </div>
      <div className="flex items-center gap-3 px-4 py-4">
        <Icon className="lucide--loader-2 h-5 w-5 flex-shrink-0 animate-spin text-gray-400" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-900">Documents are currently processing</p>
          <p className="mt-0.5 text-xs text-gray-500">
            Total document counts may be inaccurate until processing completes. Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
}

interface StageCardProps {
  config: StageConfig;
  count: number;
  action?: React.ReactNode;
}

export function StageCard({ config, count, action }: StageCardProps) {
  return (
    <div className="flex gap-2.5">
      <div className={`mt-1.5 h-2.5 w-2.5 flex-shrink-0 rounded-full ${config.bgColor}`} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-900">
            {count.toLocaleString()} {config.name}
          </span>
          {action}
        </div>
        <p className="text-xs text-gray-500">{config.description}</p>
      </div>
    </div>
  );
}
